/**
 * Define a bunch of state names which can be used to determine the current state of the program
 *
 * taken from https://medium.com/@decker/pseudo-enums-in-javascript-how-to-implement-a-router-in-vue-js-c73f8113157c
 */

const states = {
  HOME: "HOME", //Viewing homepage
  GENERATING: "GENERATING", //generating results for the first time
  VIEWING: "VIEWING", //viewing results
  FETCHING: "FETCHING", //fetching the results of a previously generated project
  REGENERATING: "REGENERATING", //Regenerating a batch
};

export default Object.freeze(states);